import gql from 'graphql-tag';

export const LocalActivityQuery = gql`
	query LocalActivityQuery {
		localActivity @client {
			id
			action
			timestamp
			content {
				id
				title
				hasRestrictions
				hasInheritedRestrictions
				space {
					id
					key
				}
				properties(keys: ["emoji-title-published", "emoji-title-draft"]) {
					nodes {
						id
						value
						key
						version {
							number
						}
					}
				}
				__typename
			}
			__typename
		}
	}
`;

export const DehydratedLocalActivityQuery = gql`
	query DehydratedLocalActivityQuery {
		localActivity @client {
			id
			action
			timestamp
			content {
				id
				__typename
			}
			__typename
		}
	}
`;
